export default {
      id: "ic-dynamic-date-green-usage",
      viewBox: "0 0 34 34",
      url: "/" + "images/icons.3.109.2.svg#ic-dynamic-date-green-usage",
      toString: function () {
        return this.url;
      }
    }